import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-movergy',
  templateUrl: './movergy.component.html',
  styleUrls: ['./movergy.component.scss'],
})
export class MovergyComponent implements OnInit {
  @Input() movergyValue: number;

  constructor() {}

  ngOnInit(): void {}
}
